"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { buildWhatsAppContactUrl } from "@/lib/contact-links";

type WhatsAppContactLinkProps = {
  children?: ReactNode;
  className?: string;
  label: string;
  showLabel?: boolean;
  labelClassName?: string;
};

function contactHandoffHref(pathname: string | null): string {
  return buildWhatsAppContactUrl(pathname);
}

export default function WhatsAppContactLink({
  children,
  className,
  label,
  showLabel = true,
  labelClassName,
}: WhatsAppContactLinkProps) {
  const pathname = usePathname();
  const resolvedLabel = label;
  const href = contactHandoffHref(pathname);

  return (
    <a
      href={href}
      className={className}
      aria-label={resolvedLabel}
    >
      {children ?? (
        <>
          <i className="bi bi-send" aria-hidden="true" />
          <span className={showLabel ? labelClassName : "visually-hidden"}>{resolvedLabel}</span>
        </>
      )}
    </a>
  );
}
